import { z } from 'zod';

import zodLocales from 'common/zod/locales';

const formSchema = z.object({
  objetSocial: z.string().min(1, { message: zodLocales.errors.required }),
});

export type FormSchema = z.input<typeof formSchema>;

export type FormSchemaValid = z.infer<typeof formSchema>;

export default formSchema;
